import React, { useState, useContext, useEffect, useCallback } from 'react';
import { Button, Badge } from 'antd';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import { useShallow } from 'zustand/react/shallow';

import { ReactComponent as Back } from 'assets/svg/back.svg';
import { ReactComponent as Bell } from 'assets/svg/bell.svg';
import { ReactComponent as Menu } from 'assets/svg/menu.svg';
import { ReactComponent as ShoppingBag } from 'assets/svg/shopping-bag.svg';
import { useUnreadCountQuery } from 'hooks/features/notification/queries';
import useSSE from 'hooks/useSSE';
import { SidebarCollapse } from 'store/actions/ConfigAction';
import { ConfigContext } from 'store/context';
import useNotificationStore from 'store/useNotificationStore';

import NotificationDrawer from './NotificationDrawer';

function AppHeader(props) {
  const { ConfigDispatch } = useContext(ConfigContext);
  const [visible, setVisible] = useState(false);
  const { unreadCount, setUnreadCount, addNotification } = useNotificationStore(
    useShallow(state => ({
      unreadCount: state.unreadCount,
      setUnreadCount: state.setUnreadCount,
      addNotification: state.addNotification,
    }))
  );
  const { count, hasData: hasUnreadCountData } = useUnreadCountQuery();
  const Classes = classNames({
    'flex justify-between items-start omi-header': true,
    'omi-header-menu-collapsed': props.status,
  });

  useEffect(() => {
    if (!hasUnreadCountData || typeof count !== 'number') {
      return;
    }

    setUnreadCount(count);
  }, [count, hasUnreadCountData, setUnreadCount]);

  const handleSSEMessage = useCallback(
    ({ data }) => {
      if (data?.id) {
        addNotification(data);
      }
    },
    [addNotification]
  );

  useSSE('api/v1/notifications/stream', {
    onMessage: handleSSEMessage,
  });

  return (
    <div className={Classes}>
      <div className="flex">
        <div className="omi-button-collapse-menu">
          <Menu onClick={() => ConfigDispatch(SidebarCollapse())} />
        </div>
        {props.redirect && (
          <div className="hidden lg:block">
            <Link to={props.redirect.link} className="omi-back-to-link text-grey-800 hover:text-grey-800">
              <Back className="inline-block mr-4" />
              <span className="align-middle font-semibold text-md">{props.redirect.name}</span>
            </Link>
          </div>
        )}
      </div>
      <div className="flex h-8 omi-header-action">
        <Button type="primary" size="small" className="rounded-omi-8 b-shipping-bag leading-0" href="/pos">
          <ShoppingBag className="inline-block" />
          Điểm bán hàng
        </Button>
        <Badge count={unreadCount} className="omi-header-noti-badge">
          <Button type="primary" onClick={() => setVisible(true)} className="rounded-omi-8 alarm">
            <Bell className="inline-block" />
          </Button>
        </Badge>
      </div>
      <NotificationDrawer visible={visible} onClose={() => setVisible(false)} />
    </div>
  );
}

export default AppHeader;
